import * as app from './views/mainapp';
import {addNamaExtenstionsToPrototypes} from "./common/NamaCommon";
import {isArabic} from "./common/Translator";

addNamaExtenstionsToPrototypes();
export {instance as instance} from './views/mainapp';
function start() {
    let messagesScript = document.createElement("script");
    messagesScript.type = "text/javascript";
    let cultureScript = document.createElement("script");
    cultureScript.type = "text/javascript";
    if (isArabic())
    {
        $('#bootstrapmain').after('<link href="bootstrap4/rtl/bootstrap.min.css" rel="stylesheet" type="text/css"/>');
        $('head').append('<link href="assets/namasoft/css/rtl.css" rel="stylesheet" type="text/css"/>');
        $('html').css('direction', 'rtl').addClass("k-rtl");
        messagesScript.src = "assets/base/kendo-ui/js/messages/kendo.messages.ar-EG.min.js";
        cultureScript.src = "assets/base/kendo-ui/js/cultures/kendo.culture.ar-EG.min.js";
    } else {
        messagesScript.src = "assets/base/kendo-ui/js/messages/kendo.messages.en-US.min.js";
        cultureScript.src = "assets/base/kendo-ui/js/cultures/kendo.culture.en-US.min.js";
    }
    $('head').append(messagesScript);
    $('head').append(cultureScript);
    kendo.culture(isArabic() ? "ar-EG" : "en-US");
    if(window.noNamaServer)
    {
        $("#Loading-Message").html("<h1>It seems that the server did not start correctly. Please contact technical support.</h1>");
        return;
    }
    app.instance.removeLoadingMessage();
}
$(start);
